
document.addEventListener("DOMContentLoaded", function() {
  // Select all checkboxes inside each .reco-choicelist element
  const checkboxes = document.querySelectorAll(".reco-choicelist input[type='checkbox']");
  const dataCurrencyPrice = document.querySelector('#MainContent').getAttribute('data-currency');
  // Select the original Add to Cart button (adjust the selector if needed)
  const originalButton = document.querySelector("product-form.product-form .product-form__buttons .product-form__submit");
  const customButtonId = "custom-add-to-cart-button";
  // Select the span where the additional price will be displayed
  const priceDisplay = document.querySelector(".addpr");

  /**
   * Sums the prices from all checked checkboxes and updates the display.
   */
  function updateAdditionalPrice() {
    let totalPrice = 0;

    checkboxes.forEach(function(checkbox) {
      if (checkbox.checked) {
        // Retrieve the price from the attribute and convert it to a number.
        // Adjust parseFloat or conversion if needed (for example, if your price is in paise).
        let price = parseFloat(checkbox.getAttribute("reco-data-price"));

      //  console.log(price);
        
        if (!isNaN(price)) {
          totalPrice += price;
        }
      }
    });

    // Example: If your prices are stored in the smallest currency unit (like paise), convert to rupees.
    const rupees = totalPrice / 100;
    if (priceDisplay) {
      priceDisplay.textContent = dataCurrencyPrice + rupees;
    }
  }

  /**
   * Updates the Add to Cart buttons.
   * If any checkbox is checked, hides the original button and creates a custom one.
   * Otherwise, removes the custom button and shows the original button.
   */
  function updateAddToCartButton() {
    // Check if any checkbox is checked
    const anyChecked = Array.from(checkboxes).some(chk => chk.checked);

    if (anyChecked) {
      if (originalButton) {
        originalButton.style.display = "none";
      }

      // If the custom button doesn't already exist, create it
      if (!document.getElementById(customButtonId)) {
        const customButton = document.createElement("button");
        customButton.id = customButtonId;
        // Add the class using classList.add (or adjust as needed)
        customButton.classList.add("product-form__submit");
        customButton.innerText = "Add to Cart"; 

        // Attach the click event listener immediately after creation
        customButton.addEventListener("click", handleCustomButtonClick);

        if (originalButton && originalButton.parentNode) {
          originalButton.parentNode.insertBefore(customButton, originalButton);
        }
      }
    } else {
      // Remove the custom button if it exists
      const customButton = document.getElementById(customButtonId);
      if (customButton && customButton.parentNode) {
        customButton.parentNode.removeChild(customButton);
      }
     
      if (originalButton) {
        originalButton.style.display = "";
      }
    }
  }

  /**
   * Combined handler for checkbox changes.
   * Updates both the additional price display and the button visibility.
   */
  function handleCheckboxChange() {
    updateAdditionalPrice();
    updateAddToCartButton();
  }

  // Add change event listener to each checkbox
  checkboxes.forEach(function(checkbox) {
    checkbox.addEventListener("change", handleCheckboxChange);
  });

  // Call once on page load so that the display is correct
//  handleCheckboxChange();

  /**
   * Handles the custom Add to Cart button click event.
   * Gathers all checked options and sends them to the cart.
   */
  function handleCustomButtonClick(e) {
    e.preventDefault();
  
    // Gather all checked inputs within the .main-optional-recommended container
    const selectedInputs = document.querySelectorAll('.main-optional-recommended input[type="checkbox"]:checked');

    const items = Array.from(selectedInputs).map(input => ({
      quantity: 1,
      id: input.value,  // The value should contain the variant ID.
    }));

    if (items.length === 0) {
      alert("No items selected to add to the cart.");
      return;
    }
    
    // Uncomment the fetch block when ready to send to the cart.
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items }), // Send the items array
    })
    .then(response => {
      if (!response.ok) {
        if (response.status === 422) {
          alert("Selected product is out of stock");
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(data => {
      // On success, redirect to the cart page.
      window.location.href = '/cart';
    })
    .catch(error => {
      console.error("Error adding products to the cart:", error);
    });
  }
});

